var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';

function SvgEye(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    d: "M4.106 15.553c.14-.281.404-.75.788-1.346a20.492 20.492 0 012.251-2.89C9.661 8.631 12.62 7 16 7c3.38 0 6.339 1.632 8.855 4.316a20.492 20.492 0 012.25 2.891c.385.596.649 1.065.79 1.346a1 1 0 010 .894c-.141.281-.405.75-.79 1.346a20.492 20.492 0 01-2.25 2.89C22.339 23.369 19.38 25 16 25c-3.38 0-6.339-1.632-8.855-4.316a20.492 20.492 0 01-2.25-2.891 15.188 15.188 0 01-.79-1.346 1 1 0 010-.894zm2.468 1.154c.575.89 1.254 1.781 2.03 2.61C10.777 21.631 13.255 23 16 23c2.745 0 5.224-1.368 7.395-3.684A18.513 18.513 0 0025.86 16a18.513 18.513 0 00-2.464-3.316C21.224 10.368 18.745 9 16 9c-2.745 0-5.224 1.368-7.395 3.684A18.513 18.513 0 006.14 16c.126.218.27.455.433.707zM16 20a4 4 0 110-8 4 4 0 010 8zm0-2a2 2 0 100-4 2 2 0 000 4z"
  }));
}

export default SvgEye;